import { render, staticRenderFns } from "./SectionBox.vue?vue&type=template&id=698286ca&scoped=true&"
import script from "./SectionBox.vue?vue&type=script&lang=js&"
export * from "./SectionBox.vue?vue&type=script&lang=js&"
import style0 from "./SectionBox.vue?vue&type=style&index=0&id=698286ca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "698286ca",
  null
  
)

export default component.exports